<template>
  <el-dialog
    :close-on-click-modal="closeOnClickModal"
    class="create-model scrollbar-default"
    title="缴费单"
    :visible.sync="visible"
    width="90%"
  >
    <div class="paySingle" v-loading="loading">
      <table class="table1" border="1" cellspacing="0" cellpadding="0">
        <tr>
          <td>业务号</td>
          <td colspan="3">
            <el-input readonly v-model="payCostData.ywh"></el-input>
          </td>
          <td>收费人</td>
          <td>
            <el-input readonly v-model="payCostData.sfr"></el-input>
          </td>
        </tr>
        <tr>
          <td>缴费人</td>
          <td>
            <el-input v-model="payCostData.jfr" readonly></el-input>
          </td>
          <td>联系电话</td>
          <td>
            <el-input v-model="payCostData.lxdh" readonly></el-input>
          </td>
          <td>坐落</td>
          <td>
            <el-input readonly v-model="payCostData.zl"></el-input>
          </td>
        </tr>
      </table>
      <div class="text-right margin-top-medium">
        <el-button class="btn" type="primary" @click="addPayProject">添加缴费项目</el-button>
        <el-button class="btn" type="primary" @click="deletePayProject">删除缴费项目</el-button>
      </div>
      <e-table
        ref="paySingleRef"
        :tableList="tableList"
        :options="options"
        :columns="columns"
        :operates="operates"
        @selectionChangeHandle="selectionChangeHandle"
      >
        <template slot="jfxmmc" slot-scope="scope">
          <dict-select v-model="scope.row.jfxmmc" type="缴费项目名称" filterable clearable  @fatherMethod="fatherMethod($event, scope.row)" ></dict-select>
        </template>
      </e-table>
      <el-row :gutter="20" class="margin-top-medium">
        <el-col :span="8">
          实收总额（元）：<span>{{ ssje }}</span>
        </el-col>
        <el-col :span="8">
          申请人（签字）：<span>{{ payCostData.sqr }}</span>
        </el-col>
        <el-col :span="8">
          日期：<span>{{ payCostData.sfrq }}</span>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button class="btn" @click="visible = false">取 消</el-button>
      <el-button class="btn" type="primary" @click="savePayProject(false)">保存</el-button>
      <el-button class="btn" type="primary" @click="printPaySingle">打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
import utils from '@/utils/utils';
import { mapGetters } from 'vuex';
import applicantSaveService from '@/pages/iebdc/api/apply/applicant-save';
import { printQlxxPay } from '@/pages/iebdc/api/my-query.js';
import { getProcessInfo } from 'iebdc/api/my-application.js';
import { localDataUser } from '../../../../utils/local-data';
export default {
  name: 'paySingle',
  data: function () {
    return {
      loading: false,
      closeOnClickModal: false,
      btnLoading: '',
      visible: false,
      ssje: '', //实收金额
      payid: '',
      user: localDataUser.get(),
      payCostData: {
        jfr: '',
        dh: '',
        sfr: '',
        zl: '',
        ywh: '',
        sqr: '',
        sfrq: '',
        ssje: '',
      },
      tableList: [],
      printParams: {},
      options: {
        // 每页数据数
        pageSize: 100,
        // 当前页码
        currentPage: 0,
        loading: false,
        mutiSelect: true,
        hasIndex: true,
        hasPagination: false
      },
      columns: [
        {
          prop: 'jfxmmc',
          label: '缴费项目名称',
          width: '120',
          align: 'center',
          type: 'dic',
          slot: true
        },
        {
          prop: 'mj',
          label: '面积(㎡)',
          width: '100',
          disabled: true,
          align: 'left',
        },
        {
          prop: 'jfjs',
          label: '缴费基数',
          align: 'left',
          width: '100'
        },
        {
          prop: 'jsje',
          label: '应收金额(元)',
          disabled: false,
          align: 'left',
          width: '100'
        },
        {
          prop: 'ssje',
          label: '实收金额(元)',
          disabled: false,
          align: 'left',
          width: '100'
        },
        {
          prop: 'ssjedx',
          label: '实收金额大写',
          align: 'left',
          disabled: true,
          width: '150'
        },
        {
          prop: 'bz',
          label: '备注',
          align: 'left',
          width: '150'
        },
      ],
      operates: {
        //表格操作栏
        width: 80,
        list: [
          {
            id: '1',
            label: '编辑',
            show: true,
            spanType: 'render',
            method: (key, row) => {
              row.editable = true;
            },
            showCallback: () => {
              return true;
            },
            render: (h, scope) => {
              const linkAttrs = {
                type: 'primary',
                underline: false,
              };
              return scope.row.editable ? (
                <el-link
                  {...{ attrs: linkAttrs }}
                  vOn:click_stop_prevent={() => {
                    console.log(scope.row);
                    this.handleSave(scope.row);
                  }}
                >
                  保存
                </el-link>
              ) : (
                <el-link
                  {...{ attrs: linkAttrs }}
                  vOn:click_stop_prevent={() => {
                    this.handleEdit(scope);
                  }}
                >
                  编辑
                </el-link>
              );
            },
          }
        ],
      },
      deleteData: [],
      rowId: 2,
      parentData: {},
      mj: '',
      zl: '',
      dyxx: {},
      jfxmmcDicValues: [], //记录缴费项目名称的字典值集合
    };
  },
  computed: {
    ...mapGetters(['dictionary']),
  },
  watch: {
    tableList: {
      handler: function (val) {
        let arr = [];
        val.forEach((item) => {
          arr.push(item.ssje);
        });
        this.ssje = this.addPrice(...arr);
        // this.$set(this.payCostData, 'ssje', this.addPrice(...arr));
      },
      deep: true,
    },
  },
  methods: {
    fatherMethod(val, row) {
      //住宅、非住宅、工本费 金额随之变化
      if (val === '10' || val === '80' || val === '550'){
        row.jsje = parseInt(val);
        row.ssje = parseInt(val);
        row.ssjedx = utils.digitalConversion(row.ssje); 
      }
    },
    handleEdit(scope) {
      this.$set(scope.row, 'editable', true);
    },
    //字典格式化
    formatDic(column, prop) {
      const dicLabel = this.$store.getters.getLabelDicByTypeAndValue(column, prop);
      return dicLabel;
    },
    init(data) {
      console.log(data);
      this.visible = true;
      this.parentData = {wwywh: data};
      // this.jfxmmcDicValues = this.getDicValueListByLabel();
      this.getSfdByYwh();
    },
    // 选择
    selectionChangeHandle(val) {
      this.deleteData = val;
      // this.deleteData = val.map(item => ({...item, checked: true}));
    },
    //获取弹框的数据
    getSfdByYwh() {
      this.loading = true;
      getProcessInfo({ wwywh: this.parentData.wwywh })
        .then((res) => {
          if (res.success) {
            this.mj = this.getMjTotal(res.data.children[0].qlxxExMhs);
            this.zl = this.getZlTotal(res.data.children[0].qlxxExMhs);
            this.dyxx = this.getDyxxTotal(res.data.children[1].ywrs);
            this.addQlxxPay({
              wwywh: this.parentData.wwywh,
              sfr: this.user.name,
              jfr: this.dyxx.dyr,
              xldh:  this.dyxx.lxdh,
              zl: this.zl,
              sqr: this.user.name
            })
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //生成缴费单
    async addQlxxPay(params) {
      const { success, data } = await applicantSaveService.addQlxxPay(params);
      if (success) {
        this.payCostData = data;
        this.ssje = this.payCostData.ssze;
        this.payCostData.sfrq = utils.dateFtt(data.rq, 'yyyy-MM-dd');
        this.payid = data.id;
        if (!data.qlxxJfd || !data.qlxxJfd.length) {
          this.tableList = [];
          this.$refs.paySingleRef.setTableList([]);
          return;
        }
        this.tableListNew(data.qlxxJfd);
      } else {
        this.$message.error('生成缴费单失败');
      }
    },
    //获取建筑面积之和
    getMjTotal(arr) {
      let mj = 0;
      (arr || []).forEach(item => {
        mj += item.jzmj;
      })
      return mj;
    },
    //获取坐落
    getZlTotal(arr) {
      let temp = [];
      (arr || []).forEach(item => {
        temp.push(item.zl);
      })
      return temp.join(',');
    },
    //获取付款人信息  取category = 5
    getDyxxTotal(arr) {
      let dyrArr = [];
      let lxdhArr = [];
      (arr || []).forEach(item => {
        if (item.category === '5') {
          dyrArr.push(item.ywrmc);
          lxdhArr.push(item.dh);
        }
      })
      return {
        dyr: dyrArr.join(','),
        lxdh: lxdhArr.join(',')
      };
    },
    handleSave(data) {
      this.ssje = this.payCostData.ssze;
      Object.keys(this.payCostData).forEach((key) => {
        if (data[key] === null) {
          this.payCostData[key] = '';
        } else {
          this.payCostData[key] = data[key];
        }
      });
      this.savePayProject(data);
    },
    //收费项数据
    tableListNew(data) {
      data.forEach((item) => {
        //缴费项目名称为工本费，住宅费，非住宅费时应收和实收金额不允许输入
        // item.disabled = this.jfxmmcDicValues.includes(item.jfxmmc);
        if (item.ssje) {
          item.ssjedx = utils.digitalConversion(item.ssje);
        }
      });
      this.tableList = data;
      this.$refs.paySingleRef.setTableList(data);
    },
    addPrice() {
      const arr = [];
      for (let i = 0; i < arguments.length; i++) {
        try {
          arr.push(arguments[i].toString().split('.')[1].length);
        } catch (e) {
          arr.push(0);
        }
      }
      let m = Math.pow(10, Math.max(...arr));
      let total = 0;
      for (let i = 0; i < arguments.length; i++) {
        total += arguments[i] * m;
      }
      return Math.round(total) / m;
    },
    //保存
    savePayProject(row) {
      if (!this.tableList.length) {
        return this.$message.warning('请添加缴费项目！');
      }
      const data = this.tableList;
      for (const item of data) {
        if (!item.jfxmmc) return this.$message.warning('请填写缴费项目名称！');
        if (!item.jfjs) return this.$message.warning('请填写缴费基数！');
        if (item.jsje === null || item.jsje === '' || item.jsje === undefined) return this.$message.warning('请填写应收金额！');
        if (item.ssje === null || item.ssje === '' || item.ssje === undefined) return this.$message.warning('请填写实收金额！');
      }
      row && this.$set(row, 'editable', false);
      this.loading = true;
      this.saveSfxx();
    },
    //保存缴费人信息
    saveSfxx() {
      applicantSaveService
        .updateQlxxPay({
          id: this.payid, 
          qlxxJfd: this.tableList, 
          ssze: this.ssje
        })
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.addQlxxPay({
              wwywh: this.parentData.wwywh,
              sfr: this.user.name,
              jfr: this.dyxx.dyr,
              xldh:  this.dyxx.lxdh,
              zl: this.zl,
              sqr: this.user.name
            })
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //打印
    printPaySingle() {
      printQlxxPay({ wwywh: this.parentData.wwywh }).then((res) => {
        if (res.data && res.success) {
          window.open(res.data);
        } else {
          this.$message.warning('下载失败!');
        }
      });
    },
    //删除缴费项信息
    deletePayProject() {
      if (!this.deleteData.length) return this.$message.warning('请先勾选数据！');
      this.tableList = this.tableList.filter(item => !this.deleteData.includes(item))
      this.saveSfxx();
    },
    filterTableList(key) {
      return this.tableList.filter((rowData) => {
        return !this.deleteData.find((deleteData) => {
          if (deleteData[key]) return deleteData[key] === rowData[key];
        });
      });
    },
    //添加缴费项信息
    addPayProject() {
      this.tableList.push({
        jfxmmc: '',
        mj: this.mj,
        jfjs: '1',
        jsje: '',
        ssje: '',
        ssjedx: '',
        bz: '',
        editable: true
      });
      this.$refs.paySingleRef.setTableList(this.tableList || []);
    },
    //表格单元格展示
    renderRes(h, row, paramsMore) {
      const { column, rowIndex } = paramsMore;
      const { funcName } = column;
      return this[funcName](h, row, column, rowIndex);
    },
    renderInput(h, row, column, rowIndex) {
      return h('el-input', {
        attrs: {
          placeholder: `请输入${column.label}`,
          clearable: true,
          disabled: ['jsje', 'ssje'].includes(column.prop) ? row.disabled : false,
          value: row[column.prop],
        },
        on: {
          input: (val) => {
            if (typeof column.ssjeAll === 'function') {
              this.ssje = column.ssjeAll(val, this.tableList, rowIndex);
            }
            if (column.prop === 'ssje') {
              this.$set(this.tableList[rowIndex], 'ssjedx', utils.digitalConversion(val));
            }
            this.$set(row, column.prop, val);
          },
        },
      });
    },
    //根据字典值名称获取对应的childrens
    getDicByType(label) {
      // this.$store.getters.getLabelDicByTypeAndValue('缴费项目名称', flow.sfkyy)
      if (this.dictionary) {
        let items = this.dictionary.find(function (item) {
          return item.label === label;
        });
        if (!items) return [];
        return items.childrens || [];
      }
    },
    getDicValueListByLabel(params = ['工本费', '住宅', '非住宅']) {
      const targetDicData = this.getDicByType('缴费项目名称');
      if (!targetDicData) return [];
      return targetDicData.reduce((valueList, data) => {
        const { label, value } = data;
        if (params.includes(label)) {
          valueList.push(value);
        }
        return valueList;
      }, []);
    },
  },
};
</script>

<style lang="scss" scoped>
.paySingle /deep/ {
  .table1 {
    width: 100%;
    border-collapse: collapse;
    tr td {
      padding: 0px 10px;
      border: 1px solid #9e9e9e;
      height: 32px;
      line-height: 32px;
    }
    input {
      border: none;
    }
  }
  .el-table__body-wrapper {
    max-height: 300px !important;
    height: 300px !important;
    overflow-y: auto;
  }
  .el-table .el-table__empty-block {
    height: 300px !important;
    min-height: 300px !important;
  }
}
</style>
